var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("work-menu"),
      _vm._v(" "),
      _vm.hasAnyRole("ROLE_ADMIN", "ROLE_WORK_READ", "ROLE_WORK_ADMIN")
        ? _c("div", { staticClass: "col-md-10 pt-3" }, [
            _c("div", [
              _c("div", { staticClass: "form-group" }, [
                _c("span", [_vm._v("年")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedYear,
                        expression: "selectedYear"
                      }
                    ],
                    staticClass: "search-select custom-select mr-1",
                    attrs: { name: "year" },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedYear = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.changeSelected
                      ]
                    }
                  },
                  _vm._l(_vm.yearList, function(year) {
                    return _c(
                      "option",
                      { key: year, domProps: { value: year } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(year) +
                            "\n                "
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("span", [_vm._v("月")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedMonth,
                        expression: "selectedMonth"
                      }
                    ],
                    staticClass: "search-select custom-select mr-1",
                    attrs: { name: "month" },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedMonth = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.changeSelected
                      ]
                    }
                  },
                  _vm._l(12, function(month) {
                    return _c(
                      "option",
                      { key: month, domProps: { value: month } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(month) +
                            "\n                "
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("span", [_vm._v("部署")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedDepartmentId,
                        expression: "selectedDepartmentId"
                      }
                    ],
                    staticClass: "search-select custom-select mr-1",
                    attrs: { name: "department" },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedDepartmentId = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.changeSelected
                      ]
                    }
                  },
                  [
                    _vm.hasAnyRole("ROLE_ADMIN", "ROLE_MANAGE")
                      ? _c(
                          "option",
                          { attrs: { value: "", selected: "selected" } },
                          [_vm._v("すべて")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.loginUser.departmentList, function(
                      current,
                      index
                    ) {
                      return _c(
                        "option",
                        {
                          key: index,
                          domProps: {
                            value: _vm.loginUser.departmentIdList[index]
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(current) +
                              "\n                "
                          )
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "/api/work/download/" +
                        _vm.selectedYear +
                        "/" +
                        _vm.selectedMonth +
                        "/excel?departmentId=" +
                        _vm.selectedDepartmentId
                    }
                  },
                  [_vm._m(0)]
                ),
                _vm._v(" "),
                _c("label", { ref: "viewAll" }, [
                  _c("input", {
                    attrs: { type: "checkbox", id: "viewAll" },
                    on: { click: _vm.checkUserView }
                  }),
                  _vm._v("退職者も表示")
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.monthlySummaryList.length == 0
              ? _c("div", [_vm._v("まだレコードはありません")])
              : _c("div", [
                  _c(
                    "table",
                    {
                      staticClass:
                        "table table-sm table-bordered table-responsive"
                    },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.monthlySummaryList, function(result) {
                          return _vm.viewAll || result.deletedAt == null
                            ? _c(
                                "tr",
                                {
                                  key: result.userId,
                                  class: { retiree: result.deletedAt }
                                },
                                [
                                  _c("td", { staticClass: "noflap" }, [
                                    _c("img", {
                                      staticClass: "card-img-top icon",
                                      attrs: {
                                        src: result.imageUrl
                                          ? result.imageUrl
                                          : "",
                                        onerror:
                                          "this.src='/src/assets/img/not_found_user_icon.jpg';"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "/admin/work/detail/" +
                                            result.userId +
                                            "?year=" +
                                            _vm.selectedYear +
                                            "&month=" +
                                            _vm.selectedMonth
                                        }
                                      },
                                      [_vm._v(_vm._s(result.userName))]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    result.hasAttachment == true
                                      ? _c("div", { staticClass: "mb-1" }, [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  "/api/work/timetable/upload/" +
                                                  _vm.selectedYear +
                                                  "/" +
                                                  _vm.selectedMonth +
                                                  "/" +
                                                  result.userId
                                              }
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "btn btn-info",
                                                  staticStyle: {
                                                    "-webkit-border-radius":
                                                      "24px,0 -moz-border-radius: 24px,0"
                                                  },
                                                  attrs: { type: "button" }
                                                },
                                                [_vm._v("添付あり")]
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    result.approvedCount == result.days
                                      ? _c(
                                          "div",
                                          { staticClass: "square_btn" },
                                          [_vm._v("承認")]
                                        )
                                      : result.confirmCount == result.days
                                      ? _c(
                                          "div",
                                          { staticClass: "square_btn1" },
                                          [_vm._v(" 確定")]
                                        )
                                      : result.remandRecuestCount == result.days
                                      ? _c(
                                          "div",
                                          { staticClass: "square_btn2" },
                                          [_vm._v(" 差戻中")]
                                        )
                                      : result.approvedCount != result.days
                                      ? _c("div", [_vm._v("未確定")])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(result.shiftName))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        result.unit && result.unit.length > 10
                                          ? result.unit.slice(0, 10) + "..."
                                          : result.unit
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(result.workCount))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(result.lateCount))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(result.leaveEarlyCount))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(result.officeHourSum))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(result.breakTimeSum))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(result.otherBreakTimeSum))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(result.midnightBreakTimeSum))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-right",
                                      staticStyle: { background: "aliceblue" }
                                    },
                                    [_vm._v(_vm._s(result.workHourSum))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-right",
                                      staticStyle: { background: "aliceblue" }
                                    },
                                    [_vm._v(_vm._s(result.overHourSum))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-right",
                                      staticStyle: { background: "aliceblue" }
                                    },
                                    [_vm._v(_vm._s(result.midnightHourSum))]
                                  )
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      )
                    ]
                  )
                ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-info",
        staticStyle: { "border-radius": "50px" },
        attrs: { type: "button" }
      },
      [
        _c("i", {
          staticClass: "fas fa-cloud-download-alt fa-1x",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v("全員分ダウンロード\n              ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "thead-light" }, [
      _c("tr", [
        _c("th", [_vm._v("氏名")]),
        _vm._v(" "),
        _c("th", [_vm._v("ステータス")]),
        _vm._v(" "),
        _c("th", [_vm._v("シフト名")]),
        _vm._v(" "),
        _c("th", [_vm._v("部署名")]),
        _vm._v(" "),
        _c("th", [_vm._v("出勤数")]),
        _vm._v(" "),
        _c("th", [_vm._v("遅刻数")]),
        _vm._v(" "),
        _c("th", [_vm._v("早退数")]),
        _vm._v(" "),
        _c("th", [_vm._v("出勤時間")]),
        _vm._v(" "),
        _c("th", [_vm._v("休憩時間")]),
        _vm._v(" "),
        _c("th", [_vm._v("その他休憩")]),
        _vm._v(" "),
        _c("th", [_vm._v("深夜帯休憩")]),
        _vm._v(" "),
        _c("th", [_vm._v("実働時間")]),
        _vm._v(" "),
        _c("th", [_vm._v("残業時間")]),
        _vm._v(" "),
        _c("th", [_vm._v("深夜帯時間")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e30e4c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e30e4c2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/admin/work/WorkMonthlySummary.vue
// module id = 446
// module chunks = 0